import { useCallback } from 'react'

import parseCategories from '../../../../services/content/parseCategories'
import { usePlayerStore } from '../../../../services/store'

export const useParseLobbyData = () => {
  const playerStore = usePlayerStore()
  const playerTagsGames = playerStore.use.tagsGames()

  const parseLobbyData = useCallback(
    (lobbyData, options) => {
      if (lobbyData) {
        return {
          id: lobbyData.entry.lobbyId,
          categories: parseCategories(
            lobbyData.entry.lobbyCategoryAssortments,
            playerTagsGames,
            options.lazyLoadedCategoryIds
          )
        }
      }

      return {
        id: 0,
        categories: []
      }
    },
    [playerTagsGames]
  )

  return { parseLobbyData }
}
